import React from 'react';
import './AboutPage.css';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants';

const AboutRow2 = () => {
  return (
    <div className='row2-container'>
      <div className='row1'>
        <div className='label'>
          <motion.div
            variants={fadeIn("down", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            className='row-title' style={{ color: '#0D65D9', fontSize: 'clamp(40px, 5.5vw, 96px)' }}>
            GROWTH CULTURE
          </motion.div>
          <motion.div
            variants={fadeIn("up", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            style={{ fontSize: 'clamp(16px, 1.5vw, 24px)', maxWidth: 1300 }} className='description'>
            At 101 White Label, our Growth Culture is the driving force behind our rapid expansion and industry leadership. Over the past five years, we've cultivated a corporate culture that thrives on innovation, adaptability, and excellence. This culture empowers us to consistently deliver cutting-edge solutions, challenge industry norms, and exceed our customers' expectations. By nurturing a dynamic and forward-thinking environment, we ensure that every step forward is a step toward sustainable growth and lasting success.
          </motion.div>
        </div>
      </div>
      <div className='row2'>
        <motion.img
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='image' src={`https://dti2k7ujq2xio.cloudfront.net/images/Laptop.webp`} alt='Laptop' loading='lazy'></motion.img>
        <div className='label'>
          <motion.div
            variants={fadeIn("left", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            className='row-title' style={{ color: '#F2F2F2', fontSize: 'clamp(40px, 5.5vw, 96px)' }}>
            DIGITAL ENTERTAINMENT IS WHAT WE DO
          </motion.div>
          <motion.div
            variants={fadeIn("left", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            className='description' style={{ width: '95%', color: '#FFFFFF', fontSize: 'clamp(16px, 1.5vw, 24px)' }}>
            At 101 White Label, we deliver exceptional and distinctive Digital Entertainment experiences. As a young and dynamic White Label provider, we are constantly innovating and creating to stay ahead in the global iGaming market. <br /><br />
            We understand that each partner has unique requirements and visions. Therefore, 101 White Label takes a customer-centric approach, actively listening and understanding to develop tailor-made iGaming platforms that seamlessly align with each client's business goals. <br /><br />
            By blending cutting-edge technology with a proactive, adaptive mindset, we are committed to providing Digital Entertainment products that are not only of the highest quality but also stand out in the marketplace. Join 101 White Label in crafting unique digital entertainment experiences and elevating your brand to new heights!
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default AboutRow2;